/**
 * Branded frame around Google Maps iframe - matches dashboard primary / glass tokens.
 */

"use client";

import { Box } from "@chakra-ui/react";
import { MAP_EMBED_CONFIG } from "@/lib/config/mapEmbed";
import { useThemeTokens } from "@/lib/theme/tokens";

export interface LocationMapEmbedProps {
  embedUrl: string;
  title?: string;
}

export const LocationMapEmbed = ({
  embedUrl,
  title = "Map preview",
}: LocationMapEmbedProps) => {
  const theme = useThemeTokens();

  return (
    <Box
      position="relative"
      w="100%"
      borderRadius={MAP_EMBED_CONFIG.innerRadius}
      overflow="hidden"
      h={MAP_EMBED_CONFIG.height}
      sx={{
        // Subtle inner edge so the map reads as “inset” in the glass UI
        boxShadow: `inset 0 0 0 1px ${theme.accent.primaryBorder}`,
      }}
    >
      <Box
        as="iframe"
        title={title}
        src={embedUrl}
        width="100%"
        height="100%"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        sx={{ display: "block" }}
      />
    </Box>
  );
};
